const getToursFilter = function (state) {
  return {...state.tour.filter}
}

const getToursOrder = function (state) {
  return {...state.tour.order}
}

const getSelectedTour = function (state) {
  return {...state.tour}
}

export default {
  getToursOrder,
  getToursFilter,
  getSelectedTour
}



// WEBPACK FOOTER //
// ./src/front/store/modules/itinerario/getters/tour.js